import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import maleSVG from '../../assets/images/profile-male.svg'
import { createAdminUser, editAdminUser, getAdminUsersById } from '../../services/admin.service'
import { showError, showLoading, stopLoading } from '../../utils/alertsUtils'
import { CustomDropdown } from '../customDropdown/customDropdown.component'
import { CustomInputField } from '../customInputField/customInputField.component'

export const UserForm = ({ isDelete, formHeading, isUpdate }) => {
    const navigate = useNavigate()
    const { id } = useParams()
    const [empName, setEmpName] = useState("")
    const [empEmail, setEmpEmail] = useState("")
    const [empRole, setEmpRole] = useState("")
    const [empPhone, setEmpPhone] = useState()
    const [isEmpActive, setIsEmpActive] = useState()

    const roles = [{ ID: 101, VALUE: "Admin" }, { ID: 152, VALUE: "Moderator" }]
    const getEmpData = async () => {
        if (id) {
            const { status, data } = await getAdminUsersById(id)
            if (status == 200 && data.length) {
                const empData = data[0]
                setEmpName(empData.EMP_NAME)
                setEmpEmail(empData.EMAIL)
                setEmpPhone(empData.EMP_MOBILE)
                setIsEmpActive(empData.IS_ACTIVE == 1 ? true : false)
                setEmpRole(empData.EMP_TYPE == 101 ? "Admin" : "Moderator")
            } else {
                navigate('/')
            }
        }
    }

    const updateempProfile = async () => {
        if (isUpdate) {
            showLoading("Updating")
            const { status } = await editAdminUser(id,empName, empEmail, empPhone, empRole, isEmpActive ? 1 : 0)
            if (status == 200) {
                setTimeout(() => {
                    stopLoading()
                    navigate("/users")
                }, 2000)
            }
        } else {
            if (empName == "") {
                showError("Employee name is required")
                return
            }
            if (empEmail == "" || empEmail == undefined) {
                showError("Employee email is required")
                return
            }
            if (empPhone == "" || empPhone == undefined) {
                showError("Employee phone is required")
                return
            }
            showLoading(`Adding Employee ${empName}`)
            const { status } = await createAdminUser(empName, empEmail, empPhone, empRole, isEmpActive ? 1 : 0)
            if (status == 200) {
                setTimeout(() => {
                    stopLoading()
                    navigate("/emp-list")
                }, 2000)
            }
        }

    }

    useEffect(() => {
        getEmpData()
    }, [])
    return (
        <>
            <div className="app-content content">
                <div className="content-overlay" />
                <div className="header-navbar-shadow" />
                <div className="content-wrapper">
                    <div className="content-body">
                        <div className="row">
                            <div className="col-lg-6 col-12">
                                <h2 className="mb-0">{formHeading}</h2>
                                <p className="font-lato font-12">User Management</p>
                            </div>
                            <div className="col-lg-6 col-12  ">
                                <div className="demo-inline-spacing float-right">
                                    <div className="custom-control custom-switch custom-switch-primary">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="customSwitch10"
                                            defaultChecked={isEmpActive}
                                            onClick={(e) => {
                                                setIsEmpActive(!isEmpActive)
                                            }}
                                        />
                                        <label
                                            className="custom-control-label w-80p font-13"
                                            htmlFor="customSwitch10"
                                        >
                                            <span className="switch-icon-left">ACTIVE</span>
                                            <span className="switch-icon-right">INACTIVE</span>
                                        </label>
                                    </div>
                                    {isDelete && <button
                                        type="button"
                                        className="btn btn-danger font-lato text-white rounded-10 font-11 waves-effect waves-float waves-light"
                                    >
                                        <i className="fas fa-trash mr-1" />
                                        Delete
                                    </button>}

                                    <button
                                        type="button"
                                        className="btn btn-primary font-lato text-white rounded-10 font-11 waves-effect waves-float waves-light"
                                        onClick={updateempProfile}
                                    >
                                        <i className={isUpdate ? "fas fa-sync mr-1" : "fas fa-paper-plane mr-1"} />
                                        {isUpdate ? "Update" : "Add"}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-9">
                                <div className="row">
                                    <CustomInputField name={"EMPLOYEE NAME"} value={empName} setValue={(e) => setEmpName(e.target.value)} />
                                    <CustomInputField name={"EMAIL ADDRESS"} value={empEmail} setValue={(e) => setEmpEmail(e.target.value)} />
                                    <CustomInputField name={"PHONE NUMBER"} value={empPhone} setValue={(e) => setEmpPhone(e.target.value)} />
                                    <div className="col-12 col-lg-6">
                                        <CustomDropdown options={roles} currentValue={empRole} name={"ROLE"} isDisable={false} setOptionValue={setEmpRole} />
                                    </div>

                                </div>
                            </div>
                            <div className="col-12 col-lg-3">
                                <div className="card card-profile">
                                    <div className="card-body">
                                        <div className="profile-image-wrapper">
                                            <div className="profile-image">
                                                <div className="avatar">
                                                    <label htmlFor="vid-upload" role="button" className="mb-0">
                                                        <img src={maleSVG} alt="img" />
                                                    </label>
                                                    <input type="file" id="vid-upload" hidden />
                                                </div>
                                            </div>
                                        </div>
                                        <h6 className="mb-0">ADD A PROFILE IMAGE</h6>
                                        <h6 className="mb-0 opacity-50">CLICK TO BROWSE</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="footer">
                                    <p className="mb-0">©2025 Protiviti Inc. All Rights Reserved.</p>
                                    <p className="mb-0">
                                        Protiviti Inc. is an Equal Opportunity Employer,
                                        M/F/Disability/Vet
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}